export interface Review {
  id: string;
  movieId: string;
  user: string;
  rating: number;
  date: string;
  content: string;
}

export const reviews: Review[] = [
  {
    id: "review-01",
    movieId: "movie-01",
    user: "雨夜看片",
    rating: 9,
    date: "2025-10-08",
    content:
      "最难得的是它没有急着解释。所有情绪都压在雨声和沉默里，散场之后反而越想越后怕。周砚的表演克制到几乎没有痕迹。",
  },
  {
    id: "review-02",
    movieId: "movie-01",
    user: "老周的电影笔记",
    rating: 8,
    date: "2025-10-04",
    content:
      "中段稍微慢了一点，但结尾没有强行给答案，这一点非常加分。国产悬疑终于有人愿意相信观众的耐心了。",
  },
  {
    id: "review-03",
    movieId: "movie-02",
    user: "云上的猫",
    rating: 9,
    date: "2025-08-21",
    content:
      "画面美到想哭，尤其是列车穿过云层那一段。它讲的是告别，但没有一句台词在说再见。看完在影院坐了很久。",
  },
  {
    id: "review-04",
    movieId: "movie-03",
    user: "南方的风",
    rating: 8,
    date: "2025-09-19",
    content:
      "服务区那场戏太真实了，两个人都不说话，但你能感觉到他们在努力。看完给我爸打了个电话。",
  },
  {
    id: "review-05",
    movieId: "movie-06",
    user: "海边散步",
    rating: 8,
    date: "2025-06-20",
    content:
      "潮湿、阴冷、克制，几乎每一帧都在滴水。结尾的选择略仓促，但人物的动机是站得住的。",
  },
  {
    id: "review-06",
    movieId: "tv-01",
    user: "追剧不睡觉",
    rating: 9,
    date: "2025-09-30",
    content:
      "二十四集几乎没有废戏，线索给得很有诚意。最喜欢的是它没有把警察写成超人，他们也会判断错、也会犹豫。",
  },
  {
    id: "review-07",
    movieId: "tv-01",
    user: "雾都来客",
    rating: 9,
    date: "2025-09-25",
    content:
      "氛围一流，港口和雾拍得太好了。建议一口气看，中间停下来会忘记线索。",
  },
  {
    id: "review-08",
    movieId: "tv-07",
    user: "一碗热汤面",
    rating: 9,
    date: "2025-09-12",
    content:
      "每集一碗面，每集一个人。它没有讲什么大事，但每一集结束都想下楼吃碗面。这才是治愈。",
  },
  {
    id: "review-09",
    movieId: "tv-10",
    user: "住在六楼",
    rating: 8,
    date: "2025-02-11",
    content:
      "住过老小区的人都会懂。电梯、楼道、漏水，全是生活本身。群像写得比想象中扎实。",
  },
  {
    id: "review-10",
    movieId: "variety-01",
    user: "山里的信号",
    rating: 9,
    date: "2025-07-02",
    content:
      "难得一档不靠任务卡推动的节目。看他们真的在地里干活、等雨停，比任何剧本都好看。",
  },
  {
    id: "review-11",
    movieId: "variety-07",
    user: "森林听众",
    rating: 10,
    date: "2025-01-08",
    content:
      "看完之后关掉了所有声音，在窗边坐了十分钟。它让人重新意识到，安静本身就是一种内容。",
  },
  {
    id: "review-12",
    movieId: "movie-10",
    user: "凌晨三点",
    rating: 9,
    date: "2025-05-16",
    content:
      "适合失眠的人看。面包出炉的那段镜头，暖得让人想哭。故事很轻，但落点很稳。",
  },
];

export const generalReviews: Review[] = [
  {
    id: "review-g1",
    movieId: "general",
    user: "普通观众",
    rating: 8,
    date: "2025-09-01",
    content:
      "整体完成度不错，节奏舒服，人物也立得住。属于那种看完会想推荐给朋友的作品。",
  },
  {
    id: "review-g2",
    movieId: "general",
    user: "周末看片",
    rating: 8,
    date: "2025-08-18",
    content:
      "细节做得很用心，画面和配乐都在线。剧情后半段略有收敛，但瑕不掩瑜。",
  },
  {
    id: "review-g3",
    movieId: "general",
    user: "片单收集者",
    rating: 7,
    date: "2025-07-30",
    content:
      "适合安静的时候看，不适合一边刷手机一边看。沉进去之后会发现很多小心思。",
  },
];